import * as React from "react";
import { pure } from "recompose";
import LayoutGrid from "@tunnel-components/layouts/layout/index";
import BreadCrumb from "@tunnel-components/@sharded/widgets/breadcrumb/component";
import BoxGrid from "@tunnel-components/@sharded/widgets/box/custom/component";
import * as Utils from "@Cyclope-Utils/index";
import * as Enums from "@tunnel-enums/index";
import * as Lodash from "lodash";
import * as Paths from "@tunnel-enums/index";
import * as i18next from "i18next";
/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const { loading, versionning, errorserver } = props;

  ///  Simple Authorization + some operations
  /**
   * @description : retourne un objet ( utilisateur )
   * @const
   * @name User
   * @type { any  }
   */
  const User: any = Utils.createdUserRoles();

  /**
   * @description : retourne un boolean ( token )
   * @const
   * @name authorization
   * @type { boolean  }
   */
  const authorization: boolean = Utils.simpleAuthorizationIsAllowed(User, [
    Enums.AuthorizationRightsEnums.INCIDENTUPDATEINHIBITION,
  ]);

  //

  /**
   * @description : retourne un boolean ( )
   * @const
   * @name siteLoading
   * @type { boolean  }
   */
  const siteLoading: boolean =
    !Lodash.isEmpty(versionning) &&
    !Lodash.isUndefined(versionning) &&
    !Lodash.isNull(versionning);

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @external
   * @name lodash
   * @infos "https://reactjs.org"
   */
  return (
    <LayoutGrid
      loading={loading}
      btnloading={loading}
      authorization={authorization}
      error={errorserver}
    >
      <section className="tunnel-site animated fadeIn ">
        <BreadCrumb
          links1={Paths.PathsNamesEnums.VERSIONNING}
          width="26"
          height="26"
          iconAdministration={true}
          title={i18next.t("administration")}
          breadText1={i18next.t("version")}
        />
        <div className="contentAllSiteWithoutOnglet">
          <section className="columnsWithoutOnglet">
            <section className="content-wrapper">
              <section className="with-3-columns" id="columns">
                <div className="versionning">
                  {siteLoading && (
                    <BoxGrid title={i18next.t("VERSIONS")} classNames="">
                      <div className="versionning-deploy">
                        <span>
                          <span>{i18next.t("version tunnelwatch")}: </span>
                          <span>{versionning.version.split(";")[0]}</span>
                        </span>
                        <span>
                          <span>{i18next.t("date de deploiement")} : </span>
                          <span>
                            {Utils.localDateFrFormatMessage(
                              versionning.version.split(";")[1]
                            )}
                          </span>
                        </span>
                      </div>
                    </BoxGrid>
                  )}
                </div>
              </section>
            </section>
          </section>
        </div>
      </section>
    </LayoutGrid>
  );
};

/** Valeurs par défaut des props */
Component.defaultProps = {};
/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  loading?: any;
  versionning?: any;
  errorserver?: any;
}
/** @export HOC pure */
export default pure(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/administration/versionning/component.tsx